import { axios } from '@/utils/request'
const api = '/Order'
export default {
  OrderList: parameter => {
    return axios({
      url: `${api}/OrderList`,
      method: 'post',
      data: parameter
    })
  },

  SaveOrderTui: parameter => {
    return axios({
      url: `${api}/SaveOrderTui`,
      method: 'post',
      data: parameter
    })
  },
  FinanceList: parameter => {
    return axios({
      url: `${api}/FinanceList`,
      method: 'post',
      data: parameter
    })
  },
  FindOrder: parameter => {
    return axios({
      url: `${api}/FindOrder`,
      method: 'post',
      data: parameter
    })
  },
  OrderTuiList: parameter => {
    return axios({
      url: `${api}/OrderTuiList`,
      method: 'post',
      data: parameter
    })
  },
  AddOrderTui: parameter => {
    return axios({
      url: `${api}/AddOrderTui`,
      method: 'post',
      data: parameter
    })
  },
  DeleteOrderTui: parameter => {
    return axios({
      url: `${api}/DeleteOrderTui`,
      method: 'post',
      data: parameter
    })
  },
  DrawList: parameter => {
    return axios({
      url: `${api}/DrawList`,
      method: 'post',
      data: parameter
    })
  },
  tongguo: parameter => {
    return axios({
      url: `${api}/tongguo`,
      method: 'post',
      data: parameter
    })
  },
  Jujue: parameter => {
    return axios({
      url: `${api}/Jujue`,
      method: 'post',
      data: parameter
    })
  },
  skuList: parameter => {
    return axios({
      url: `${api}/skuList`,
      method: 'post',
      data: parameter
    })
  },
  orderExport: (parameter) => {
    return axios({
      url: `${api}/orderExport`,
      method: 'post',
      data: parameter
    })
  },
}
